// if (!customElements.get("compare-products")) {
//   customElements.define(
//     "compare-products",
//     class CompareProducts extends HTMLElement {
//       constructor() {
//         super(); 
//         this.loaddata(); 
//       }
//       connectedCallback() {
//         const handleIntersection = (entries, observer) => {
//           if (!entries[0].isIntersecting) return;
//           observer.unobserve(this);
//         };
//         new IntersectionObserver(handleIntersection.bind(this), {
//           rootMargin: "0px 0px 400px 0px",
//         }).observe(this);
//       }
//       loaddata() {
//         var csvurl =
//            $(this).find('.compare-products-container').data('csvfile');
//         var jsonarr = [];
//         console.log("tesssssst " + $(this).find('.compare-products-container').data('csvfile'));
//         var this3 = this;

//         $.ajax({
//           type: "GET",
//           url: csvurl,
//           dataType: "text",
//           success: function (data) {
//             var csvData = data;
//             let word_array = $.csv.toArrays(csvData);

//             console.log(word_array.length + "  ddddd");

//             var ob = {};
//             for (let index = 1; index < word_array.length; index++) {
//               ob[word_array[index][1]] = {};

//               for (let j = 2; j < word_array[index].length; j++) {
//                 ob[word_array[index][1]][word_array[0][j]] =
//                   word_array[index][j];
//               }
//             }

//             console.log(word_array);
           
//             setDataInPage(ob);
//           },
//         });

//         function setDataInPage(data) {
           
//           for (var key in data) {
//             for (var keyin in data[key]) {
//               if (data.hasOwnProperty(key)) {
                
//                 $(
//                   '.row-content .row-column[data-product="' +
//                     key +
//                     '"][data-key="' +
//                     keyin +
//                     '"]'
//                 ).html(data[key][keyin]);
//               }
//             }
//           }
//           $('.compare-product-select:not(:checked)').parents('.product-select-tab').removeClass('active');
//           $('.compare-product-select:checked').parents('.product-select-tab').addClass('active');
//           $('.compare-product-select').change(function(){
//             $('.compare-product-select:not(:checked)').parents('.product-select-tab').removeClass('active');
//             $('.compare-product-select:checked').parents('.product-select-tab').addClass('active');
//              var checkcount = $('.compare-product-select:checked').length; 
//              if(this.checked) {
//                 if(checkcount == 3){
//                   $('.compare-product-select:not(:checked)').parents('.product-select-tab').attr('disabled',true);
//                 }
//                 $('.row-column').addClass('compare-hide'); 
//                 $('.compare-product-select:checked').each(function(){ 
//                   var pid = $(this).data('pid');
//                   $('.row-column[data-product="'+pid+'"]').removeClass('compare-hide');
//                 })  
//              }else{
//                 $('.compare-product-select:not(:checked)').parents('.product-select-tab').attr('disabled',false);
//                 $('.row-column').addClass('compare-hide'); 
//                 $('.compare-product-select:checked').each(function(){
                  
//                   var pid = $(this).data('pid');
//                   $('.row-column[data-product="'+pid+'"]').removeClass('compare-hide');
//                 })   
//              }
//              $('.row-column').removeClass('row-2-col'); 
//              $('.row-column').removeClass('row-1-col'); 
//              $('.row-column').removeClass('row-3-col');
//              if(checkcount == 1){
//                $('.row-column').addClass('row-1-col');
//              }else if(checkcount == 2){
//                $('.row-column').addClass('row-2-col');
//              }else if(checkcount == 3){
//                $('.row-column').addClass('row-3-col');
//              }  
//               $('.select-count').html(`${checkcount}/3 selected`);
//               if(checkcount == 0){
//                 $('.product-compare-container').hide();
//                 $('.none-selected').show()   
//               }else{
//                 $('.product-compare-container').show();
//                 $('.none-selected').hide()
//               }
//           })
//         }
//       }
//     }
//   );
// }


// if (!customElements.get("compare-products")) {
//   customElements.define(
//     "compare-products",
//     class CompareProducts extends HTMLElement {
//       constructor() {
//         super(); 
//         this.loaddata(); 
//       }
//       connectedCallback() {
//         const handleIntersection = (entries, observer) => {
//           if (!entries[0].isIntersecting) return;
//           observer.unobserve(this);
//         };
//         new IntersectionObserver(handleIntersection.bind(this), {
//           rootMargin: "0px 0px 400px 0px",
//         }).observe(this);
//       }
//       loaddata() {
//         var csvurl =
//            $(this).find('.compare-products-container').data('csvfile');
//         var jsonarr = [];
//         console.log("tesssssst " + $(this).find('.compare-products-container').data('csvfile'));
//         var this3 = this;

//         $.ajax({
//           type: "GET",
//           url: csvurl,
//           dataType: "text",
//           success: function (data) {
//             var csvData = data;
//             let word_array = $.csv.toArrays(csvData);

//             console.log(word_array.length + "  ddddd");

//             var ob = {};
//             for (let index = 1; index < word_array.length; index++) {
//               ob[word_array[index][1]] = {};

//               for (let j = 2; j < word_array[index].length; j++) {
//                 ob[word_array[index][1]][word_array[0][j]] =
//                   word_array[index][j];
//               }
//             }

//             console.log(word_array);
           
//             setDataInPage(ob);
//           },
//         });

//         function setDataInPage(data) {
//           for (var key in data) {
//             for (var keyin in data[key]) {
//               if (data.hasOwnProperty(key)) {
//                 $(
//                   '.row-content .row-column[data-product="' +
//                     key +
//                     '"][data-key="' +
//                     keyin +
//                     '"]'
//                 ).html(data[key][keyin]);
//               }
//             }
//           }
//           $('.compare-product-select:not(:checked)').parents('.product-select-tab').removeClass('active');
//           $('.compare-product-select:checked').parents('.product-select-tab').addClass('active');
//           $('.compare-product-select').change(function(){
//             $('.compare-product-select:not(:checked)').parents('.product-select-tab').removeClass('active');
//             $('.compare-product-select:checked').parents('.product-select-tab').addClass('active');
//              var checkcount = $('.compare-product-select:checked').length; 
//              if(this.checked) {
//                 if(checkcount == 3){
//                   $('.compare-product-select:not(:checked)').parents('.product-select-tab').attr('disabled',true);
//                 }
//                 $('.row-column').addClass('compare-hide'); 
//                 $('.compare-product-select:checked').each(function(){ 
//                   var pid = $(this).data('pid');
//                   $('.row-column[data-product="'+pid+'"]').removeClass('compare-hide');
//                 })  
//              }else{
//                 $('.compare-product-select:not(:checked)').parents('.product-select-tab').attr('disabled',false);
//                 $('.row-column').addClass('compare-hide'); 
//                 $('.compare-product-select:checked').each(function(){
//                   var pid = $(this).data('pid');
//                   $('.row-column[data-product="'+pid+'"]').removeClass('compare-hide');
//                 })   
//              }
//              $('.row-column').removeClass('row-2-col'); 
//              $('.row-column').removeClass('row-1-col'); 
//              $('.row-column').removeClass('row-3-col');
//              if(checkcount == 1){
//                $('.row-column').addClass('row-1-col');
//              }else if(checkcount == 2){
//                $('.row-column').addClass('row-2-col');
//              }else if(checkcount == 3){
//                $('.row-column').addClass('row-3-col');
//              }  
//               $('.select-count').html(`${checkcount}/3 selected`);
//               if(checkcount == 0){
//                 $('.product-compare-container').hide();
//                 $('.none-selected').show()   
//               }else{
//                 $('.product-compare-container').show();
//                 $('.none-selected').hide()
//               }
//           })
//         }
//       }
//     }
//   );
// }


if (!customElements.get("compare-products")) {
  customElements.define(
    "compare-products",
    class CompareProducts extends HTMLElement {
      constructor() {
        super(); 
        this.loaddata(); 
      }
      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
        };
        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
      loaddata() {
        var csvurl =
           $(this).find('.compare-products-container').data('csvfile');
        var jsonarr = [];
        console.log("tesssssst " + $(this).find('.compare-products-container').data('csvfile'));
        var this3 = this;

        $.ajax({
          type: "GET",
          url: csvurl,
          dataType: "text",
          success: function (data) {
            var csvData = data;
            let word_array = $.csv.toArrays(csvData);

            console.log(word_array.length + "  ddddd");

            var ob = {};
            for (let index = 1; index < word_array.length; index++) {
              ob[word_array[index][1]] = {};

              for (let j = 2; j < word_array[index].length; j++) {
                ob[word_array[index][1]][word_array[0][j]] =
                  word_array[index][j];
              }
            }

            console.log(word_array);
           
            setDataInPage(ob);
          },
        });

        function setDataInPage(data) {
          for (var key in data) {
            for (var keyin in data[key]) {
              if (data.hasOwnProperty(key)) {
                $(
                  '.row-content .row-column[data-product="' +
                    key +
                    '"][data-key="' +
                    keyin +
                    '"]'
                ).html(data[key][keyin]);
              }
            }
          }

          // Initialize selection logic
          $('.compare-product-select:not(:checked)').parents('.product-select-tab').removeClass('active');
          $('.compare-product-select:checked').parents('.product-select-tab').addClass('active');

          // Handle checkbox changes
          $('.compare-product-select').change(function(){
            var checkcount = $('.compare-product-select:checked').length;

            // If more than 3 items are selected, uncheck the current one
            if (checkcount > 3) {
              $(this).prop('checked', false);
              return;
            }

            // Update active states
            $('.compare-product-select:not(:checked)').parents('.product-select-tab').removeClass('active');
            $('.compare-product-select:checked').parents('.product-select-tab').addClass('active');

            // Enable/disable unchecked tabs based on selection count
            if (checkcount == 3) {
              $('.compare-product-select:not(:checked)').parents('.product-select-tab').attr('disabled', true);
            } else {
              $('.compare-product-select:not(:checked)').parents('.product-select-tab').attr('disabled', false);
            }

            // Show/hide columns based on selection
            $('.row-column').addClass('compare-hide'); 
            $('.compare-product-select:checked').each(function(){ 
              var pid = $(this).data('pid');
              $('.row-column[data-product="'+pid+'"]').removeClass('compare-hide');
            });

            // Update column classes based on selection count
            $('.row-column').removeClass('row-1-col row-2-col row-3-col');
            if (checkcount == 1) {
              $('.row-column').addClass('row-1-col');
            } else if (checkcount == 2) {
              $('.row-column').addClass('row-2-col');
            } else if (checkcount == 3) {
              $('.row-column').addClass('row-3-col');
            }

            // Update selection count text
            $('.select-count').html(`${checkcount}/3 selected`);

            // Show/hide the comparison table based on selection count
            if (checkcount == 0) {
              $('.product-compare-container').hide();
              $('.none-selected').show();
            } else {
              $('.product-compare-container').show();
              $('.none-selected').hide();
            }
          });
        }
      }
    }
  );
}